import { createContext } from "react";
import getLocalizedString from "./GetLocalizedString";

const LocaleContext = createContext((key) => getLocalizedString(key, null));

export default LocaleContext;
